export const filterCtas = (ctas, isLoggedIn) => {
    if (!ctas)
        return [];
    return ctas.filter((cta) => {
        switch (cta.additionalBehavior) {
            case null:
                return true;
            case "onlyForLoggedIn":
                return isLoggedIn;
            case "onlyForNotLoggedIn":
                return !isLoggedIn;
            case "always":
                return true;
            default:
                return false;
        }
    });
};
export const buildHeroContent = (slide, isLoggedIn, isContainerWidth = false) => {
    return {
        title: isLoggedIn && slide.content.titleLogged ? slide.content.titleLogged : slide.content.title,
        subheadline: isLoggedIn && slide.content.subheadlineLogged ? slide.content.subheadlineLogged : slide.content.subheadline,
        text: isLoggedIn && slide.content.textLogged ? slide.content.textLogged : slide.content.text,
        logo: slide.logo,
        logoWidth: slide.logoWidth,
        logoHeight: slide.logoHeight,
        logoAlt: slide.logoAlt,
        discounts: slide.content.discounts,
        tagLine: slide.content.tagLine,
        legalDisclaimer: slide.legalDisclaimer,
        displayScrollBar: slide.displayScrollBar,
        cta: filterCtas(slide.content.cta, isLoggedIn),
        //fixme: it should have a proper values inherited from AEM properties both aem and loyalty
        isViewportHeight: slide.isViewportHeight ?? true,
        isContainerWidth: isContainerWidth ?? false,
        hasGradientLeft: slide.hasGradientLeft ?? false,
        isHeroCardsShown: slide.content.cards && slide.content.cards.length > 1,
        renderImage: slide.renderImage,
        logoReference: slide.logoReference,
    };
};
//# sourceMappingURL=buildHeroContent.js.map